import { render, staticRenderFns } from "./shop_order.vue?vue&type=template&id=397fadb3&scoped=true"
import script from "./shop_order.vue?vue&type=script&lang=ts"
export * from "./shop_order.vue?vue&type=script&lang=ts"
import style0 from "./shop_order.vue?vue&type=style&index=0&id=397fadb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397fadb3",
  null
  
)

export default component.exports